const BOLETO_CANCEL_ERRORS_ENUM = {
  M1_CH_ERR_051: 'INSUFFICIENT_FUNDS',
  M1_CH_ERR_050: 'INCORRECT_BANK_DETAILS',
  GENERIC: 'GENERIC'
}

const getErrorBasedOnCode = (code = BOLETO_CANCEL_ERRORS_ENUM.GENERIC) => {
  return (
    BOLETO_CANCEL_ERRORS_ENUM[code.toUpperCase()] ??
    BOLETO_CANCEL_ERRORS_ENUM.GENERIC
  )
}

const isInsufficientFunds = error =>
  error.toLowerCase() === BOLETO_CANCEL_ERRORS_ENUM.M1_CH_ERR_050.toLowerCase()
const isIncorrectBankDetails = error =>
  error.toLowerCase() === BOLETO_CANCEL_ERRORS_ENUM.M1_CH_ERR_050.toLowerCase()
const isGeneric = error =>
  error.toLowerCase() === BOLETO_CANCEL_ERRORS_ENUM.GENERIC.toLowerCase()

const isBoletoCancelError = error =>
  Object.keys(BOLETO_CANCEL_ERRORS_ENUM)
    .map(error => error.toLowerCase())
    .includes(error.toLowerCase())

export {
  BOLETO_CANCEL_ERRORS_ENUM,
  getErrorBasedOnCode,
  isIncorrectBankDetails,
  isInsufficientFunds,
  isBoletoCancelError,
  isGeneric
}
